import { render, staticRenderFns } from "./o-half-text.vue?vue&type=template&id=751ad5ca&scoped=true"
import script from "./o-half-text.vue?vue&type=script&lang=js"
export * from "./o-half-text.vue?vue&type=script&lang=js"
import style0 from "./o-half-text.vue?vue&type=style&index=0&id=751ad5ca&prod&lang=scss"
import style1 from "./o-half-text.vue?vue&type=style&index=1&id=751ad5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751ad5ca",
  null
  
)

export default component.exports